<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawerOpen"
      :mini-variant.sync="mini"
      app
      width="250"
      height="100%"
      class="elevation-0"
      dark
      :temporary="isMobile"
      :style="{ background: isMobile ? '#1e1e2f' : 'linear-gradient(180deg, #1e1e2f 0%, #2a2a3d 100%)' }"
    >
      <div class="d-flex flex-column h-100 py-3">
        <v-list dense>
          <v-list-item class="mb-4">
            <v-list-item-title class="text-h6 font-weight-bold">
              InvoiceSnap
            </v-list-item-title>
          </v-list-item>

          <v-list-item-group v-model="selectedItem" color="primary">
            <template v-for="(item, index) in sidebarItems">
              <v-list-group
                v-if="item.submenu && item.submenu.length > 0"
                :key="item.name"
                :value="openDropdown === index"
                @click="toggleDropdown(index)"
                :prepend-icon="item.icon"
                active-class="active-menu"
              >
                <template #activator>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="(subitem, subIndex) in item.submenu"
                  :key="`${item.name}-${subIndex}`"
                  @click="goTo(`/user/${subitem.name}`)"
                  class="pl-8"
                  :class="{ 'active-menu': $route.path === `/user/${subitem.name}` }"
                >
                  <v-list-item-title>{{ subitem.title }}</v-list-item-title>
                </v-list-item>
              </v-list-group>

              <v-list-item
                v-else
                :key="item.name"
                @click="selectItem(item.name)"
                :class="{ 'active-menu': $route.path === `/user/${item.name}` }"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-spacer></v-spacer>

        <v-list dense>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="showInstallButton" @click="installApp" class="mt-6">
            <v-list-item-icon>
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Download</v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-app-bar dark app flat :height="isMobile ? '48' : '56'" class="px-2">
      <v-app-bar-nav-icon @click="drawerOpen = !drawerOpen">
        <v-icon :size="isMobile ? '28' : '24'">{{ drawerOpen ? 'mdi-menu-open' : 'mdi-menu' }}</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title v-if="!isMobile" class="text-h6 font-weight-bold">
        {{ appInfo.application_name }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

<v-menu bottom offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" class="mx-1">
        <v-icon :size="isMobile ? '28' : '24'">mdi-bell</v-icon>
        <v-badge v-if="unreadCount > 0" color="red" :content="unreadCount" overlap />
      </v-btn>
    </template>
    <v-sheet :max-height="isMobile ? '80vh' : '400px'" class="overflow-y-auto">
      <v-list>
        <v-list-item
          v-for="(notification, index) in allNotifications"
          :key="index"
          @click="openNotification(index)"
          :class="{ 'unread-notification': !notification.read }"
        >
          <v-list-item-icon>
            <v-icon :color="notification.read ? 'grey' : 'primary'">
              {{ notification.read ? 'mdi-bell-outline' : 'mdi-bell' }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ notification.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ notification.time }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              v-if="notification.url"
              icon
              small
              @click.stop="openUrl(notification.url)"
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider />
        <v-list-item v-if="allNotifications.length > 0">
          <v-btn block @click="clearNotifications" color="error" text>
            Clear All Notifications
          </v-btn>
        </v-list-item>

        <v-list-item v-else>
          <v-list-item-title class="text-center grey--text">
            No new notifications
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-menu>

  <!-- Notification Details Dialog -->
  <v-dialog v-model="dialogNotification" max-width="500">
    <v-card>
      <v-card-title class="headline">
        {{ selectedNotification.title }}
      </v-card-title>
      <v-card-text>
        <p><strong>Message:</strong> {{ selectedNotification.message }}</p>
        <p><strong>Time:</strong> {{ selectedNotification.time }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="selectedNotification.url"
          color="primary"
          @click="openUrl(selectedNotification.url)"
        >
          Open Link
        </v-btn>
        <v-btn color="secondary" @click="dialogNotification = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

      <v-menu bottom right transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar size="32">
              <img :src="$getImage(user.image_name, user.image_url)" :alt="user.full_name" />
            </v-avatar>
          </v-btn>
        </template>
        <v-list class="elevation-3 rounded-lg" style="min-width: 200px;">
          <v-list-item>
            <v-avatar size="40" class="mr-2">
              <img :src="$getImage(user.image_name, user.image_url)" :alt="user.full_name" />
            </v-avatar>
            <div>
              <span class="font-weight-bold">{{ user.full_name }}</span>
              <br />
              <small class="text-muted">{{ user.email }}</small>
            </div>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="viewProfile">
            <v-list-item-icon>
              <v-icon class="text-muted">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon class="text-muted">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main :style="{ marginLeft: isDesktop && drawerOpen ? '250px' : '0', transition: 'margin-left 0.3s ease' }">
      <v-container fluid>
      <v-alert
          v-if="subscriptionStore.error"
          type="error"
          dismissible
          @input="subscriptionStore.clearError"
        >
          {{ subscriptionStore.error }}
        </v-alert>
        <v-alert
          v-if="subscriptionStore.isFreePlan && !subscriptionStore.loading"
          type="info"
          dismissible
        >
          You are on the free plan with limited features. <router-link to="/user/account">Upgrade now</router-link> for full access.
        </v-alert>
        <router-view></router-view>
        <v-snackbar
          v-model="snackbar.visible"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          bottom
          rounded="pill"
          elevation="2"
        >
          {{ snackbar.message }}
          <template v-slot:action>
            <v-btn icon @click="snackbar.visible = false">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>

<!-- Bottom Navigation for Mobile -->
  <v-bottom-navigation
    v-model="activeItem"
    class="bottom-nav d-block d-md-none"
    color="primary"
    app
    fixed
    elevation="6"
    height="64"
  >
    <div class="bottom-nav-container">
      <v-btn
        v-for="(item) in bottomItems"
        :key="item.name"
        :value="item.name"
        @click="goTo(`/user/${item.name}`)"
        class="bottom-nav-btn"
        :class="{ 'active-btn': $route.path === `/user/${item.name}` }"
        :aria-label="`${item.title} navigation`"
        :aria-current="$route.path === `/user/${item.name}` ? 'page' : undefined"
        min-width="80"
        height="100%"
        text
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="btn-content">
              <v-badge
                v-if="item.badge && item.badge > 0"
                :content="item.badge"
                color="error"
                overlap
                offset-x="12"
                offset-y="12"
                class="badge"
                aria-hidden="true"
              >
                <v-icon
                  :size="$vuetify.breakpoint.xs ? 26 : 28"
                  class="nav-icon"
                >
                  {{ item.icon }}
                </v-icon>
              </v-badge>
              <v-icon
                v-else
                :size="$vuetify.breakpoint.xs ? 26 : 28"
                class="nav-icon"
              >
                {{ item.icon }}
              </v-icon>
              <span class="bottom-nav-label">
                {{ item.title }}
              </span>
              <span
                v-if="$route.path === `/user/${item.name}`"
                class="active-indicator"
              ></span>
            </div>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </v-btn>
    </div>
  </v-bottom-navigation>

    <v-footer :class="{ 'ml-250': isDesktop && drawerOpen }" class="d-none d-md-block" app>
      <small>Developed by <a href="http://kems2art.com" target="_blank">kems2art</a></small>
    </v-footer>

    <v-dialog v-model="dialogVisible" persistent max-width="450" rounded="lg">
  <v-card rounded="lg" elevation="4">
        <v-card-title class="headline d-flex justify-center" style="background-color: #f5f5f5;">
          <v-icon class="mr-2" color="primary">mdi-exit-to-app</v-icon>
          Logout Confirmation
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" class="text-center">
                <p>You are about to log out of your account.</p>
                <p><strong>Make sure you've saved your work</strong> before proceeding.</p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <v-alert type="warning" outlined>
                  Logging out will terminate your current session. Are you sure?
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end" style="background-color: #f9f9f9;">
          <v-btn color="blue darken-2" text @click="confirmLogout" class="white--text">
            <v-icon left>mdi-check-circle</v-icon> Yes, Logout
          </v-btn>
          <v-btn color="grey" text @click="cancelLogout">
            <v-icon left>mdi-cancel</v-icon> Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { useNotificationsStore } from '@/store/notifications';
import { debounce } from 'lodash';
import { useSubscriptionStore } from '@/store/subscription';

export default {
  name: 'UserLayout',
  setup() {
    const notificationsStore = useNotificationsStore();
    const subscriptionStore = useSubscriptionStore();
    return { notificationsStore, subscriptionStore };
  },
  data() {
    return {
      activeItem: null,
      isOnline: navigator.onLine,
      searchDialog: false,
      showSessionModal: false,
      showInstallButton: false,
      drawerOpen: true,
      mini: false,
      dialogVisible: false,
      openDropdown: null,
      appInfo: {},
      snackbar: {
        visible: false,
        message: '',
        timeout: 3000,
        color: '',
      },
      selectedItem: null,
      sidebarItems: [
        { name: 'dashboard', title: 'Dashboard', icon: 'mdi-view-dashboard' },
        { name: 'clients', title: 'Clients', icon: 'mdi-account-group' },
        { name: 'invoices', title: 'Invoices', icon: 'mdi-file-document-multiple' },
        { name: 'payments', title: 'Payments', icon: 'mdi-credit-card-multiple' },
        { name: 'account', title: 'Account', icon: 'mdi-account-cog' },
        { name: 'company', title: 'Company', icon: 'mdi-office-building' },
        { name: 'email-settings', title: 'Email Settings', icon: 'mdi-email' },
        { name: 'payment-settings', title: 'Payment Settings', icon: 'mdi-bank-transfer' },
        { name: 'email-templates', title: 'Email Templates', icon: 'mdi-email' }
      ],
      bottomItems: [
        { name: 'dashboard', title: 'Dashboard', icon: 'mdi-view-dashboard' },
        { name: 'invoices', title: 'Invoices', icon: 'mdi-file-document-multiple' },
        { name: 'payments', title: 'Payments', icon: 'mdi-credit-card-multiple' },
        { name: 'clients', title: 'Clients', icon: 'mdi-account-group' },
      ],
      //user: this.$store.getters.getUser,
      dialogNotification: false,
      selectedNotification: {},
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    flatSidebarItems() {
      // Filter out items with submenus or flatten them if needed
      return this.sidebarItems.filter(item => !item.submenu || item.submenu.length === 0);
    },
    unreadCount() {
      return this.notificationsStore.unreadNotifications.length;
    },
    allNotifications() {
      return this.notificationsStore.allNotifications;
    }
  },
  watch: {
    '$route.path'(newPath) {
      // Sync activeItem with current route
      const matchedItem = this.flatSidebarItems.find(item => `/user/${item.name}` === newPath);
      this.activeItem = matchedItem ? matchedItem.name : null;
    },
  },
  async mounted() {
    if (this.$store.state.user?.user_id) {
      this.subscriptionStore.setUserId(this.$store.state.user.user_id);
    }
    if (window.deferredPrompt) {
      this.showInstallButton = true;
    }
    // Set initial active item based on current route
    const matchedItem = this.flatSidebarItems.find(item => `/user/${item.name}` === this.$route.path);
    this.activeItem = matchedItem ? matchedItem.name : null;

    if (window.deferredPrompt) {
      this.showInstallButton = true; // Show the install button if we can prompt
    }
    // Load notifications from Pinia
    this.notificationsStore.loadNotifications();

    // Service worker listener for new notifications
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data && event.data.type === "NEW_NOTIFICATION") {
        this.notificationsStore.addNotification(event.data.notification);
      }
    });

    window.addEventListener('resize', this.updateScreenSize);
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenSize);
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    clearNotifications() {
      this.notificationsStore.clearNotifications();
    },
    receiveNotification(notification) {
      const newNotification = {
        title: notification.title,
        message: notification.message,
        url: notification.url || "",
        time: new Date().toLocaleString(),
        read: false,
      };
      this.notificationsStore.addNotification(newNotification);
    },
    openNotification(index) {
      const notification = this.notificationsStore.allNotifications[index];
      if (!notification) {
        console.error("Notification not found at index:", index);
        return;
      }
      
      this.selectedNotification = { ...notification };
      this.notificationsStore.markAsRead(index);
      this.dialogNotification = true;
    },
    openUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
      this.dialogNotification = false;
    },
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
      this.showSnackbar(this.isOnline ? 'success' : 'warning', 
        this.isOnline ? 'Back online' : 'You are offline');
    },
    handleSelectClient(client) {
      if (client && client.client_id) {
        this.$router.push(`/user/clients/view/${client.client_id}`);
        this.searchDialog = false;
      }
    },
    handleClientCleared() {
      console.log('Client selection cleared');
    },
    
    viewProfile() {
      this.goTo('/user/profile');
    },
    settings() {
      this.goTo('/user/company');
    },
    showSnackbar(type, message) {
      this.snackbar = {
        visible: true,
        message,
        timeout: 3000,
        color: type,
      };
    },
    installApp() {
      if (window.deferredPrompt) {
        window.deferredPrompt.prompt();
        window.deferredPrompt.userChoice.then((choiceResult) => {
          this.showSnackbar(
            choiceResult.outcome === 'accepted' ? 'success' : 'info',
            choiceResult.outcome === 'accepted' ? 'App installed' : 'Installation cancelled'
          );
          window.deferredPrompt = null;
          this.showInstallButton = false;
        });
      }
    },
    updateScreenSize: debounce(function () {
      this.$forceUpdate();
    }, 300),
    goTo(route) {
      if (this.$route.path !== route) {
        this.$router.push(route).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
      if (this.isMobile) this.drawerOpen = false;
    },
    logout() {
      this.dialogVisible = true;
    },
    async confirmLogout() {
      this.dialogVisible = false;
      await this.performLogout();
    },
    cancelLogout() {
      this.dialogVisible = false;
    },
    toggleDropdown(index) {
      this.openDropdown = this.openDropdown === index ? null : index;
      this.selectedItem = null;
    },
    selectItem(itemName) {
      this.selectedItem = itemName;
      this.openDropdown = null;
      this.goTo(`/user/${itemName}`);
    },
    async performLogout() {
      try {
        await this.$store.dispatch('logout');
        sessionStorage.clear();
        localStorage.removeItem('auth_token');
        this.$router.push('/login');
        this.showSnackbar('success', 'Logged out successfully');
      } catch (error) {
        this.showSnackbar('error', 'Logout failed, please try again');
      }
    },
  },
  created() {
    this.$root.showSnackbar = this.showSnackbar;
  },
};
</script>
<style scoped>
  .v-app-bar {
  background: linear-gradient(90deg, #1e1e2f 0%, #2a2a3d 100%) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.bottom-nav {
  height: 64px !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 240, 240, 0.95) 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

.bottom-nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.bottom-nav-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-width: 80px;
  padding: 8px 4px;
  transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
  position: relative;
  background: transparent;
}

.bottom-nav-btn:hover,
.bottom-nav-btn:focus {
  transform: scale(1.1);
  background: rgba(25, 118, 210, 0.1);
  border-radius: 8px;
}

.bottom-nav-btn .btn-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.nav-icon {
  transition: transform 0.2s ease, color 0.2s ease;
}

.bottom-nav-label {
  font-size: 0.7rem;
  font-weight: 500;
  color: #424242;
  text-transform: capitalize;
  line-height: 1.1;
  margin-top: 4px;
  transition: color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}

.active-btn {
  color: #1976d2 !important;
  transform: scale(1.05);
}

.active-btn .nav-icon,
.active-btn .bottom-nav-label {
  color: #1976d2 !important;
}

.active-indicator {
  position: absolute;
  bottom: 0;
  width: 28px;
  height: 3px;
  background: #1976d2;
  border-radius: 2px 2px 0 0;
  transition: width 0.2s ease;
}

.badge {
  transition: transform 0.2s ease;
}

.active-btn .badge {
  transform: scale(1.1);
}

@media (max-width: 360px) {
  .bottom-nav {
    height: 60px !important;
  }

  .bottom-nav-btn {
    min-width: 60px;
    padding: 6px 2px;
  }

  .nav-icon {
    font-size: 24px !important;
  }

  .bottom-nav-label {
    font-size: 0.65rem;
    max-width: 60px;
  }

  .active-indicator {
    width: 24px;
  }
}
</style>
